export const DEFAULT_LOADING_BUTTON_FONT_SIZE = 15
export const MESSAGE_PART_OVERLAY_HEIGHT = 390
export const AUTH_FORM_MESSAGE_SEND_DELAY = 600
